export default "__VITE_ASSET__3Bqqw2lq__"